const getters = {
    playList: state => state.playList.playList,
    musicInfo: state => state.playerState.musicInfo,
    isPlaying: state => state.playList.isPlaying,
    currentTime: state => state.playList.currentTime,
    showOpenApp: state => state.showOpenApp.showOpenApp
}
export default getters
